

import { useLoggedGeladaMutation } from '@netfront/gelada-identity-library';

import { UPDATE_UNIT } from './useUpdateGroupUnit.graphql';
import {
  IUseUpdateGroupUnit,
  IUpdateGroupUnitMutationGraphQLResponse,
  IUseUpdateGroupUnitOptions,
  IUpdateGroupUnitMutationVariables,
  IHandleUpdateGroupUnitParams,
} from './useUpdateGroupUnit.interfaces';

const useUpdateGroupUnit = (options?: IUseUpdateGroupUnitOptions): IUseUpdateGroupUnit => {
  const { mutation, onCompleted, onError, product, tokens } = options ?? ({} as IUseUpdateGroupUnitOptions);

  const [executeUpdateGroupUnit, { loading: isLoading }] = useLoggedGeladaMutation<
    IUpdateGroupUnitMutationGraphQLResponse,
    IUpdateGroupUnitMutationVariables
  >({
    mutation: mutation ?? UPDATE_UNIT,
    options: {
      onCompleted: ({
        unit: {
          update: unit,
        },
      }) => {
        if (!onCompleted) {
          return;
        }

        onCompleted({
          unit,
        });
      },
      onError,
    },
    product,
    tokens,
  });

  const handleUpdateGroupUnit = async ({
    unitName,
    unitId,
  }: IHandleUpdateGroupUnitParams) => {
    await executeUpdateGroupUnit({
      variables: {
        unitName,
        unitId,
      },
    });
  };

  return {
    handleUpdateGroupUnit,
    isLoading,
  };
};

export { useUpdateGroupUnit };
